module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 6
// module chunks = 0